"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionType = void 0;
exports.PermissionType = {
  name: 'PermissionType',
  type: 'taxonomy',
  autoRoutes: ['list', 'create', 'update'],
  select: {
    queryFields: "\n      openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n    "
  }
};